import styled from "styled-components"

export const WidgetGrid = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  gap: 12px;

  & > div {
    flex: 1;
  }

  .mobile & {
    flex-direction: column;
    gap: 16px;
    padding: 0 12px 40px;
  }
`
